// extracted by mini-css-extract-plugin
export default {"icon":"UserMenu_icon__H9Bj3","title":"UserMenu_title__ywO+z","menuItem":"UserMenu_menuItem__HRHgV","menu":"UserMenu_menu__ohagF","button":"UserMenu_button__-UeNY"};